import React from "react";

// This HoC receives a skewed and a color prop that will
// render the skewed based on the value of this props
//-----------------------------------------------------
// Prop options for skewed are:
// * bottom = Shows the bottom skewed
// * top = Shows the top skewed
// * both = Shows both skeweds, top and bottom
// * false = will render a plain section without skeweds
// Prop options for color are:
// * "transparent" - will render a transparent background color
// * white (default) - will render with a white background color

const Section = ({ children, skewed, color = "white" }) => {
	return (
		<div className="relative w-full p-4">
			<div className="absolute inset-0 flex items-center justify-center ">
				<div
					className={`absolute top-0 left-0 right-0 h-full 
          ${color === "transparent" ? "bg-transparent" : "bg-white"}
          ${
				(skewed === "top" || skewed === "both") &&
				"origin-top-left -skew-y-2 transform "
			}`}
				/>
			</div>
			<div
				className={`relative z-20 overflow-hidden w-full flex flex-col items-center justify-center container mx-auto gap-10 md:gap-28 py-12 md:py-32
        ${(skewed === "bottom" || skewed === "both") && "mb-2"}`}
			>
				{children}
			</div>
			<div className="absolute inset-0">
				<div
					className={`absolute top-0 left-0 right-0 h-full 
          ${color === "transparent" ? "bg-transparent" : "bg-white"}
          ${
				(skewed === "bottom" || skewed === "both") &&
				"origin-bottom-right -skew-y-2 transform"
			}`}
				/>
			</div>
		</div>
	);
};

export default Section;
